import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgAccident(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 -4 16 24" {...props}>
      <path
        d="M16.707 5.707a1 1 0 11-1.414-1.414 1 1 0 111.414 1.414zM6.647 8.913c-.139.139-.322.108-.409-.067L5.129 6.63c-.212-.424-.204-.813.336-1.354L9.278 1.46c.516-.517.928-.55 1.353-.336l2.216 1.108c.174.087.205.27.065.41l-6.265 6.27zm8.254-1.339l-3.327 3.328a.337.337 0 01-.476-.476l3.328-3.327a.336.336 0 11.475.475zm-6.609 5.134a1.002 1.002 0 011.415-1.415 1.001 1.001 0 01-1.415 1.415zm5.776-11.103a1.806 1.806 0 01-.677-.161L10.94.218c-.708-.353-1.635-.287-2.194.271L4.49 4.746c-.559.56-.626 1.485-.272 2.193L5.445 9.39c.087.177.16.48.16.678v.655c0 .561.453 1.469 1.013 2.028l2.533 2.533.51.506c.276.28.73.28 1.01 0l1.013-1.013a.718.718 0 000-1.014l-.507-.506 6.08-6.08.506.507c.28.28.734.28 1.015 0L19.79 6.67a.717.717 0 000-1.012l-3.04-3.04c-.558-.56-1.465-1.014-2.027-1.014h-.655z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Accident')(SvgAccident);
